import React from 'react';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';

import './styles.scss';
import { useTranslation } from '@common/hooks/translation';

export const ResultDetailsHeader = ({ gameList, competitionName, routePrefix }) => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { sportType, regionAlias } = useParams();

  if (!gameList?.length) return null;

  return (
    <div className="details-header">
      <div className="racing-back-button" onClick={() => navigate(`${routePrefix}/racings/${sportType}/result/${regionAlias}/`)}>
        <i className="global-icon icon-slim-arrow-left" />
      </div>
      {/* <span
        className={`flag icon-${gameList[0]?.games[0]?.RegionAlias?.toLowerCase().replaceAll(' ', '')} flag`}
      /> */}
      <span>
        {gameList.length === 1 ? (
          moment.unix(gameList[0]?.games[0]?.start_ts).format('ddd, DD MMM')
        ) : (
          <div className="region-info">
            <span
              className={`flag icon-${gameList[0]?.games[0]?.RegionAlias?.toLowerCase().replaceAll(' ', '')} flag`}
            />
            {t(competitionName)}
          </div>
        )}
      </span>
    </div>
  );
};
